module.exports = __webpack_public_path__ + "img/copy_file.png?v=60a98b72";